import React, { useEffect, useState, useCallback } from "react";
import { Button, Table, Pagination, Switch, Modal } from "antd";
import { MdEdit, MdDelete } from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";
import { getEmployee, setTableData } from "../store/dataSlice";
import {
  deleteSelectedRawMaterial,
  setSelectedRaw,
  toggleNewDialog,
  updateSelectedRawMaterial,
} from "../store/stateSlice";
import { FaRegEye } from "react-icons/fa";

const RawMaterialTable = ({ handleRefresh }) => {
  const dispatch = useDispatch();
  const data = useSelector(
    (state) => state.rawMaterial.state?.selectedRawMaterial
  );

  const onEdit = (index, record) => {
    console.log("record", record);
    dispatch(setSelectedRaw(record));
  };
  const onDelete = (index) => {
    dispatch(deleteSelectedRawMaterial(index));
  };
  const columns = [
    {
      title: <span className="text-gray-500">Action</span>,
      dataIndex: "action",
      width: 100,
      fixed: "left",
      render: (_, record, index) => (
        <>
          <div className="flex items-center">
            <span
              onClick={() => onEdit(index, record)}
              className="text-2xl text-[#096CAE] cursor-pointer"
            >
              <MdEdit />
            </span>
            <span
              onClick={() => onDelete(index, record)}
              className="text-2xl text-[#cf1623] cursor-pointer"
            >
              <MdDelete />
            </span>
          </div>
        </>
      ),
    },
    {
      title: <span className="text-gray-500">Date</span>,
      dataIndex: "date",
      width: 150,
    },

    {
      title: <span className="text-gray-500">Raw Material</span>,
      dataIndex: "Product",
      key: "rawMaterial",
      width: 150,
      render: (text, record) => {
        const { v_code, part_name, description } = record.Product;
        return (
          <>
            {v_code}
            <br />
            {part_name}
            <br />
            {description}
          </>
        );
      },
    },

    {
      title: <span className="text-gray-500">Quantity</span>,
      dataIndex: "quantity",
      width: 150,
    },
    {
      title: <span className="text-gray-500">Description</span>,
      dataIndex: "description",
      width: 150,
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        bordered
        scroll={{
          x: 1300,
        }}
        // onChange={handleTableChange}
        // pagination={{
        //   current: pageIndex,
        //   pageSize: pageSize,
        //   showSizeChanger: true,
        //   pageSizeOptions: [5, 10, 20],
        //   onShowSizeChange: handleTableChange,
        // }}
        // pagination={false} // disable built-in pagination
      />
    </>
  );
};
export default RawMaterialTable;
